import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-drop-down-single',
  templateUrl: './button-drop-down-single.component.html',
  styleUrls: ['./button-drop-down-single.component.scss'],
})

/** Button with drop-down list which contains only single element in drop-down list
 * uses as selector with list which contains obly one element in drop list
 */

export class ButtonDropDownSingleComponent { // toDo: remove after overlay-pop-up merge
  @Input() simpleData: any[]; // array of objects typed by user
  @Input() buttonType = 'accent';
  @Input() additionalClass: string;
  @Input() selectedItem: string;
  @Input() displayedItem = '';
  @Output() itemEmitter = new EventEmitter<any>();
}
